import { observer } from 'mobx-react-lite'
import { useEffect, useRef } from 'react'
import { runInAction } from 'mobx'

import { store } from '../stores/store'
import { useRunState } from './provider/useRunState'
import { useTrackController } from './models/track/useTrackController'

/**
 * When parents landing requests level complete, snap the run to the finish line
 * and enter the same win sequence as a normal level complete (`completeRun`).
 */
export const ParentsLandingSceneSetup = observer(
    function ParentsLandingSceneSetup() {
        const runState = useRunState()
        const trackController = useTrackController()
        const pending = store.parentsLandingLevelCompletePending
        const landingActive = store.parentsCardLandingActive
        const hasBootstrappedRef = useRef(false)

        const trackLength = trackController.getTrackLength()

        useEffect(() => {
            if (!pending || hasBootstrappedRef.current || trackLength <= 0) {
                return
            }

            hasBootstrappedRef.current = true

            trackController.setTrackPosition(trackLength)
            trackController.setSpeedMultiplier(0)
            trackController.beginEndDeceleration()

            const cardStats = store.parentsCardStats

            runInAction(() => {
                store.setTrackDistance(trackLength)
                store.setTrackProgress(1)
                runState.snapshot.finishLineReached = true
                runState.snapshot.finishLineZ = trackLength

                // Drive the level-complete card from the decoded `?cID` stats.
                if (cardStats) {
                    runState.snapshot.lifes = cardStats.remainingHearts
                    runState.snapshot.runEndStats = {
                        ...runState.snapshot.runEndStats,
                        coinPowerUpsCollected: cardStats.coinsCollected,
                        batteryPowerUpsCollected: cardStats.batteryPowerUpsCollected,
                        planePowerUpsCollected: cardStats.starPowerUpsCollected,
                        shieldPowerUpsCollected: cardStats.shieldPowerUpsCollected,
                    }
                }
            })

            runState.completeRun()
            store.clearParentsLandingLevelCompletePending()
        }, [pending, trackLength, runState, trackController])

        useEffect(() => {
            if (!landingActive) {
                hasBootstrappedRef.current = false
            }
        }, [landingActive])

        return null
    },
)
